import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postBulkUploadServicesMaster } from "apis";
import { getServicesMasterAutosuggestQuery } from "./use-get-services-master-autosuggest";
import { getServicesMasterInfiniteScrollQuery } from "./use-get-services-master-infinite-query";
import { useMyAccessProfileV2 } from "../../tryst/get-my-access-profile";

export default function usePostBulkUploadServicesMaster() {
  const queryClient = useQueryClient();
  const { data: myAccessProfile } = useMyAccessProfileV2();

  return useMutation(postBulkUploadServicesMaster, {
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries(
          getServicesMasterAutosuggestQuery({
            owner_id: myAccessProfile?.business?.id!,
          })
        );
        queryClient.invalidateQueries(
          getServicesMasterInfiniteScrollQuery({
            owner_id: myAccessProfile?.business?.id!,
          })
        );
      }, 500);
    },
  });
}
